export default "__VITE_ASSET__DHUU9Was__"